import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface MostCommentedTopic {
  id: string;
  title: string;
  content: string | null;
  author_id: string | null;
  category_id: string;
  is_pinned: boolean;
  is_locked: boolean;
  view_count: number;
  reply_count: number;
  last_reply_at: string;
  created_at: string;
  updated_at: string;
  username: string | null;
  avatar_url: string | null;
  category_name: string;
  category_color: string;
  category_slug: string;
  slug: string;
  hot_score: number;
  last_post_id: string | null;
  parent_category_id: string | null;
  parent_category_slug: string | null;
}

export interface PaginatedMostCommentedTopicsResult {
  data: MostCommentedTopic[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
}

export const useMostCommentedTopics = (page = 1, limit = 10) => {
  return useQuery({
    queryKey: ['most-commented-topics', page, limit],
    queryFn: async (): Promise<PaginatedMostCommentedTopicsResult> => {
      return { data: [], totalCount: 0, totalPages: 0, currentPage: page };
    },
    enabled: false,
  });
};